/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Password_HintInputs */

const en_admin_create_password_hint = /** @type {(inputs: Admin_Create_Password_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum 8 characters recommended`)
};

const de_admin_create_password_hint = /** @type {(inputs: Admin_Create_Password_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestens 8 Zeichen empfohlen`)
};

/**
* | output |
* | --- |
* | "Minimum 8 characters recommended" |
*
* @param {Admin_Create_Password_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_password_hint = /** @type {((inputs?: Admin_Create_Password_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Password_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_password_hint(inputs)
	return en_admin_create_password_hint(inputs)
});